import { useQuery } from '@tanstack/react-query';
import { getEvent } from '@src/api/manualAlerts';
import { get } from 'lodash';
import { trackQueryError } from '@utils/sensor/apptracker';

const defaultValue = null;

function useFetchEvent({ eventId = null, enabled = true }) {
  return useQuery(
    ['manual-alert-event', eventId],
    () => {
      return getEvent(eventId, { params: {} }).then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: enabled && !!eventId,
      staleTime: 5 * 60 * 1000, // 5m
      placeholderData: defaultValue,
      onError: (err) => {
        trackQueryError({ type: 'manual-alert-pre-diag', err });
      },
    },
  );
}

export default useFetchEvent;
